import { render, staticRenderFns } from "./ReturnedRialReport.vue?vue&type=template&id=2bdc99a9"
import script from "./ReturnedRialReport.vue?vue&type=script&lang=js"
export * from "./ReturnedRialReport.vue?vue&type=script&lang=js"
import style0 from "./ReturnedRialReport.vue?vue&type=style&index=0&id=2bdc99a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports